import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Text } from 'foundations-components/components/Text';
import LoadingPropertyValue from 'framework-asset-preview-lib/internal/properties/components/propertyValues/LoadingPropertyValue';
import EmptyPropertyValue from 'framework-asset-preview-lib/internal/properties/components/propertyValues/EmptyPropertyValue';
import PropertySection from 'framework-asset-preview-lib/internal/properties/components/propertySections/PropertySection';
import { jsx as _jsx } from "react/jsx-runtime";
export default function StatisticPropertySection({
  crmObject,
  formatStyle,
  getValue,
  loadingStatistics,
  properties,
  propertyName,
  statisticObject,
  direction = 'row',
  valueAlignment = 'right',
  truncateLabel,
  label
}) {
  const translationKey = `frameworkAssetPreviewLib.propertyLabel.${crmObject.objectTypeId}.${propertyName}`;
  const renderLabel = useCallback(() => {
    if (loadingStatistics) {
      return /*#__PURE__*/_jsx(LoadingPropertyValue, {});
    }
    if (label) {
      return /*#__PURE__*/_jsx(Text, {
        as: "span",
        children: label
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationKey
    });
  }, [loadingStatistics, translationKey, label]);
  return /*#__PURE__*/_jsx(PropertySection, {
    crmObject: crmObject,
    direction: direction,
    properties: properties,
    propertyName: propertyName,
    renderLabel: label || isValidI18nKey(translationKey) ? renderLabel : undefined,
    renderValue: () => {
      if (loadingStatistics) {
        return /*#__PURE__*/_jsx(LoadingPropertyValue, {});
      }
      const value = getValue();
      if (value == null && !statisticObject) {
        return /*#__PURE__*/_jsx(EmptyPropertyValue, {});
      }

      // @bend-expect trellis-tokenized as per https://hubspot.slack.com/archives/C1WG3L3J6/p1747665753573949?thread_ts=1743087841.396339&cid=C1WG3L3J6
      return /*#__PURE__*/_jsx(Text, {
        as: "div",
        textAlign: valueAlignment === 'right' ? 'end' : 'start',
        children: /*#__PURE__*/_jsx(FormattedNumber, {
          value: value,
          precision: 2,
          style: formatStyle
        })
      });
    },
    truncateLabel: truncateLabel
  });
}